// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'PT Sans', 'PT Sans Fallback'"},"className":"__className_978d34"};